function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12.315 24.465a3.8 3.8 0 103.801-3.799h-.001a3.804 3.804 0 00-3.8 3.799zM6.259 28.267a3.8 3.8 0 10-3.8-3.801 3.804 3.804 0 003.8 3.801zM21.952 24.465a3.8 3.8 0 103.801-3.799h-.001a3.804 3.804 0 00-3.8 3.799z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M31.185 30.915a6.877 6.877 0 00-5.377-2.575 6.879 6.879 0 00-4.649 1.793.331.331 0 01-.444 0 7.095 7.095 0 00-9.428 0 .332.332 0 01-.445 0 6.878 6.878 0 00-4.648-1.795 6.877 6.877 0 00-5.379 2.576.667.667 0 00.519 1.085h29.333a.667.667 0 00.519-1.086zM11.525 12.667h8.964a.668.668 0 00.64-.849 5.218 5.218 0 00-3.373-3.532 4.331 4.331 0 10-3.493.012 5.363 5.363 0 00-3.377 3.52.667.667 0 00.639.855zM6.667 16c0 .736.597 1.333 1.333 1.333h.637a.332.332 0 01.327.267l.4 1.993a1.334 1.334 0 102.61-.526l-.267-1.333a.331.331 0 01.327-.4h7.933a.33.33 0 01.327.4l-.267 1.333a1.334 1.334 0 102.613.525l.4-1.993a.333.333 0 01.327-.267H24a1.333 1.333 0 000-2.666H8c-.736 0-1.333.597-1.333 1.333v.003z"
});

function SvgConferenceRoom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, props), _ref, _ref2);
}

export default SvgConferenceRoom;